import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchRecalculateTasksList = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRecalculateTasksList',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, {
    startFromDate: moment(payload.params.inputDate).format('YYYY-MM-DD'),
    impcList: payload.params.impcCodes,
  });
};

export default apiFetchRecalculateTasksList;
